<template>
    <v-container>
        <div class="text-left" style="margin-bottom:20px;">
            <router-link to="/janvegas">
                <v-btn
                    color="secondary"
                    class="text-right"
                    style="width:250px"
                >
                    Back
                </v-btn>
            </router-link>
        </div>   
        <v-row>
            <v-col cols="3">
            </v-col>
            <v-col cols="9">
                <div class="text-left">
                    <p>Singapore Airlines Lounge</p>
                    <img alt="Singapore Airlines Lounge" class="uitk-image-media" src="/vegasjan/SydneyLounge.jpeg" style="width: 40%; height: auto;">
                </div>
            </v-col>
            <v-col cols="3">
            </v-col>
            <v-col cols="9">
                <div class="text-left">
                    <p><s>12:25PM</s> 1:15pm Sydney</p>
                        
                </div>
            </v-col>
            <v-col cols="3">
            </v-col>
            <v-col cols="9">
                <div class="text-left">
                    <p><s>6:30AM</s> 7:24am San Francisco</p>
                    <p>Customs and border control (10 minutes with MPC) about 90 minutes in the normal line</p>
                    <p>Collect checked bag 15 minutes wait</p>
                    <p>Recheck bag 2 minutes</p>
                    <p>Walk to TSA for terminal F 10 minutes</p>
                    <p>TSA (via United Premier line 5 minutes) normal line 15 minutes</p>
                    <p>Buy medium coke at Burger King $6.42 ($10.23)</p>
                </div>
            </v-col>
        </v-row>
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
    }
  }
  </script>